// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2nsIS","title":"Header_title__1pj2E","titleWrapper":"Header_titleWrapper__35C4T","actions":"Header_actions__2FC6u"};